import React from 'react';
import PropTypes from 'prop-types';
import IncludedFeatures from './IncludedFeatures';
import { clientLogger } from '../../../lib/logger';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';

const DetailsFeatures = ({
  componentContent,
  fptiImpression,
  handleClickFPTI,
  toolName
}) => {
  try {
    const { title, subtitle, features, style } = componentContent;
    if (!title || !features) {
      fireDetailsPageComponentFailureFpti({
        data: { title, features },
        componentName: 'DetailsFeatures',
        fptiImpression
      });
      return null;
    }

    const buff = parseData(features);
    const featureItemValues = Object.values(buff);
    //#f5f7fa is the default color for older components

    let styleObject = { backgroundColor: '#f5f7fa' };

    if (style) {
      try {
        styleObject = JSON.parse(style);
      } catch (error) {
        clientLogger.warn(
          `Corrupt JSON in the style object ${style}, Error : ${error}`
        );
      }
    }

    return (
      <section id="details-whats-included" style={styleObject}>
        <div className="details-whats-included-container">
          <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
          <p
            className="details-whats-included-split "
            dangerouslySetInnerHTML={{ __html: subtitle }}
            onClick={e =>
              e.target.tagName === 'A' &&
              e.target.getAttribute('data-fptilinkname')
                ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
                : {}
            }
            role="presentation"
          ></p>
          <IncludedFeatures
            featureItemValues={featureItemValues}
            handleClickFPTI={handleClickFPTI}
            toolName={toolName}
          />
        </div>
      </section>
    );
  } catch (error) {
    clientLogger.warn('Error parsing details feature item', error);
    return null;
  }
};

DetailsFeatures.propTypes = {
  componentContent: PropTypes.object,
  title: PropTypes.string,
  desc: PropTypes.string,
  icon: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string
};

export default DetailsFeatures;
